import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SafeCrmWebchat from "./components/SafeCrmWebchat";
import CookieBanner from "./components/CookieBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import CotacaoPage from "./pages/CotacaoPage";
import ProductPage from "./pages/ProductPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <SafeCrmWebchat />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="top-right"
          richColors
          theme="light"
          toastOptions={{
            style: { fontFamily: "Manrope, sans-serif" },
          }}
        />
        <Routes>
          {/* Public */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/cotacao" element={<PublicLayout><CotacaoPage /></PublicLayout>} />
          <Route path="/seguros/:slug" element={<PublicLayout><ProductPage /></PublicLayout>} />
          <Route path="/sobre" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/contato" element={<PublicLayout><ContactPage /></PublicLayout>} />
          <Route path="/politica-privacidade" element={<PublicLayout><LegalPage kind="privacidade" /></PublicLayout>} />
          <Route path="/termos-uso" element={<PublicLayout><LegalPage kind="termos" /></PublicLayout>} />
          <Route path="/cookies" element={<PublicLayout><LegalPage kind="cookies" /></PublicLayout>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/cotacoes"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<PublicLayout><HomePage /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
